import { Box, Container, Divider, Grid } from "@mui/material";
import Skeleton from "../../../common/skeleton/skeleton";

function IntFlightSkeleton() {
    return (
        <Container maxWidth="xl">
            <Grid container item xs={12} rowGap={2} justifyContent="space-between" alignItems="flex-start">
                <Grid className="base-sort" container item xs={2} rowGap={1} display={{ xs: "none", md: "flex" }}>
                    <Skeleton variant="rounded" animation="wave" width="100%" height={30} />
                    <Skeleton variant="rounded" animation="wave" width="100%" height={200} />
                </Grid>

                <Grid container item xs={12} columnGap={2} display={{ xs: "flex", md: "none" }} alignItems="center" mt={2}>
                    <Skeleton variant="text" animation="wave" width={50} height={20} />
                    <Divider flexItem orientation="vertical" />
                    <Skeleton variant="text" animation="wave" width={50} height={20} />
                </Grid>

                <Grid container item md={9.8} rowGap={2}>
                    <Grid className="base-sort" container item xs={12} md="auto" columnGap={2} display={{ xs: "none", md: "flex" }}>
                        {[...Array(4)].map((_, index) => (
                            <Grid key={index} container item xs="auto">
                                <Skeleton variant="text" animation="wave" width={100} height={20} />
                            </Grid>
                        ))}
                    </Grid>

                    {[...Array(10)].map((_, index) => (
                        <Grid className="flight-item" key={index} container item xs={12} rowGap={1} justifyContent="space-between" p={2}>
                            <Grid container item xs={12} md={9}>
                                <Grid container item xs={12} md={6} rowGap={1}>
                                    <Grid container item xs={12} columnGap={1}>
                                        <Skeleton variant="text" animation="wave" sx={{ width: { xs: 50, md: 80, height: { xs: 10, md: 40 } } }} />
                                        <Skeleton variant="text" animation="wave" sx={{ width: { xs: 50, md: 80, height: { xs: 10, md: 40 } } }} />
                                        <Skeleton variant="text" animation="wave" sx={{ width: { xs: 50, md: 80, height: { xs: 10, md: 40 } } }} />
                                    </Grid>

                                    <Grid container item xs={12} columnGap={1} alignItems="center">
                                        <Skeleton variant="circular" animation="wave" width={30} height={30} />
                                        <Skeleton variant="circular" animation="wave" width={30} height={30} />
                                        <Skeleton variant="circular" animation="wave" width={30} height={30} />
                                        <Box>
                                            <Skeleton variant="text" animation="wave" height={20} sx={{ width: { xs: 80, md: 200 } }} />
                                            <Skeleton variant="text" animation="wave" height={20} sx={{ width: { xs: 120, md: 150 } }} />
                                        </Box>
                                    </Grid>
                                </Grid>

                                <Grid container item xs={6} alignItems="center" display={{ xs: "none", md: "flex" }}>
                                    <Box>
                                        <Skeleton variant="text" animation="wave" width={200} height={20} />
                                        <Skeleton variant="text" animation="wave" width={300} height={20} />
                                        <Skeleton variant="text" animation="wave" width={400} height={20} />
                                    </Box>
                                </Grid>
                            </Grid>

                            <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", md: "flex" } }} />
                            <Divider width="100%" sx={{ display: { xs: "flex", md: "none" } }} />

                            <Grid container item xs={12} md={2.5} direction="column" justifyContent="center" alignItems="center">
                                <Skeleton
                                    variant="text"
                                    animation="wave"
                                    height={20}
                                    sx={{ width: { xs: 0, md: 80 }, display: { xs: "none", md: "flex" } }}
                                />
                                <Skeleton variant="text" animation="wave" width="80%" height={80} />
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Container>
    );
}

export default IntFlightSkeleton;
